module.exports = __webpack_public_path__ + "img/dime_logo_gold.ff584d67.png";